import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setShowLoginPopup, setShowSignupPopup } from 'redux-thunk/redux/slices/gameSetting.slice'

export const usePreLogin = ({ path } = {}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { loginData } = useSelector((state) => state.auth)

  const handleRegister = useCallback((options) => {
    if (loginData?.accessToken) return

    // Ignore click events from `onClick={handleRegister}`
    const showLogin = options?.nativeEvent ? false : options?.showLoginPopup === true

    if (showLogin) {
      dispatch(setShowSignupPopup(false))
      dispatch(setShowLoginPopup(true))
    } else {
      dispatch(setShowLoginPopup(false))
      dispatch(setShowSignupPopup(true))
    }
  }, [dispatch, loginData?.accessToken])

  useEffect(() => {
    if (loginData?.accessToken && path) {
      history.push(path)
    }
  }, [loginData])

  return { handleRegister }
}
